import { Col, Divider, Row } from 'antd';
import React, { FC, useContext } from 'react';
import { customFormatMessage } from 'utils';
import { ConsumablesContext } from './consumables';
import {
  CouponTypeEnum,
  ConsumablePointsOperatorEnum,
  ConsumableNatureEnum,
} from 'src/shared/enums/consumables.enum';
import { IRootReducers } from 'src/reducers';
import { connect } from 'react-redux';
import { config } from 'config/config';
import { PlatformEnum } from 'src/shared/enums';

const { ADVOCACY, RECURRENCE, EXPERIENTIAL, CUSTOM, DISCOVERY } =
  CouponTypeEnum;
const { MULTIPLY } = ConsumablePointsOperatorEnum;
const { CON_DEUTSCHLAND } = PlatformEnum;

const mapStateToProps = (state: IRootReducers) => {
  return {
    scanData: state.app.scanData,
  };
};

type Props = ReturnType<typeof mapStateToProps>;

const TableSummaryPoints: FC<Props> = ({ scanData }): JSX.Element => {
  const { selectedCustomerCoupon, welcome } = useContext(ConsumablesContext);

  const welcomePoints = 300;

  const getBonusCopy = () => {
    const firstScan =
      selectedCustomerCoupon.type !== ADVOCACY
        ? false
        : selectedCustomerCoupon.pointsOperator === MULTIPLY
        ? true
        : false;

    if (welcome) {
      return customFormatMessage('consumables.points-modal.welcome-points');
    } else {
      switch (selectedCustomerCoupon?.type) {
        case ADVOCACY:
          return customFormatMessage(
            firstScan
              ? 'consumables.points-modal.first-sample-coupon-type'
              : 'consumables.points-modal.repeated-sample-coupon-type',
          );
        case RECURRENCE:
          return customFormatMessage(
            'consumables.points-modal.recurrence-coupon-type',
          );
        case CUSTOM:
          return customFormatMessage(
            'consumables.points-modal.birthday-coupon-type',
          );
        case EXPERIENTIAL:
          return customFormatMessage(
            'consumables.points-modal.first-sample-coupon-type',
          );
        case DISCOVERY:
          return customFormatMessage(
            'consumables.points-modal.discovery-coupon-type',
          );
      }
    }
  };

  function printPrettyPoints(): string {
    let pointsLabel = 'pts';
    const platform = config.APP.PLATFORM;
    if (platform === CON_DEUTSCHLAND) {
      pointsLabel = 'Pkt';
    }
    return pointsLabel;
  }

  const getBonusPoints = () => {
    if (welcome) {
      return welcomePoints;
    } else {
      if (selectedCustomerCoupon?.pointsOperator === MULTIPLY) {
        return getTotalPoints() - scanData.newCoupon?.consumableScanPoints;
      }
    }

    return selectedCustomerCoupon?.points;
  };

  const getTotalPoints = () => {
    if (welcome) {
      return scanData.consumable.points.scanPoints + welcomePoints;
    } else {
      if (selectedCustomerCoupon?.pointsOperator === MULTIPLY) {
        return (
          scanData.newCoupon?.consumableScanPoints *
          selectedCustomerCoupon?.points
        );
      }
    }

    return (
      selectedCustomerCoupon?.points + scanData.consumable.points.scanPoints
    );
  };

  return (
    <Row justify="center">
      <div className="consumables-containerPoints">
        <Row
          className="consumables-contentPoints__totalPoints"
          justify="space-between">
          <p className="consumables-contentPoints__left">
            {customFormatMessage('consumables.points-modal.won-points')}
          </p>
          <p className="consumables-contentPoints__right">
            + {getTotalPoints()} {printPrettyPoints()}
          </p>
        </Row>
        <Row justify="center">
          <Divider className="consumables-contentPoints__divider" />
        </Row>
        <Row
          className="consumables-contentPoints__partialPoints"
          justify="space-between">
          <Col>
            <div className="consumables-contentPoints__left ">
              <div className="icon icon--scanCircle consumables-contentPoints__text-icon iconSpace"></div>
              <p className="consumables-contentPoints__text-icon text-next-icon">
                {customFormatMessage('consumables.points-modal.scan')}{' '}
                {scanData.qrInfo?.product}
              </p>
            </div>
          </Col>
          <Col>
            <p className="consumables-contentPoints__right">
              + {scanData.newCoupon?.consumableScanPoints} {printPrettyPoints()}
            </p>
          </Col>
        </Row>
        <Row
          className="consumables-contentPoints__partialPoints"
          justify="space-between">
          <Col>
            <div className="consumables-contentPoints__left">
              <div
                className={`icon icon--${
                  welcome ? 'points' : 'ticket'
                } consumables-contentPoints__text-icon iconSpace`}
              />
              <p className="consumables-contentPoints__text-icon">
                {getBonusCopy()}
              </p>
            </div>
          </Col>
          <p className="consumables-contentPoints__right">
            + {getBonusPoints()} {printPrettyPoints()}
          </p>
        </Row>
      </div>
    </Row>
  );
};

export default connect(mapStateToProps, null)(TableSummaryPoints);
